import React, { useCallback, useState } from 'react';
import { SelectProps, Spin } from 'antd';

import { useGLAccountIdentifierList } from 'api/glaccount';
import { Select } from 'components/Layout/Form';

interface IdentifierSelectProps extends SelectProps {
  showId?: boolean;
  params?: {
    lookup_type: string[];
  };
}

export const GLAcountSelect = ({ params, showId, ...props }: IdentifierSelectProps) => {
  const [search, setSearch] = useState(null);

  const handleSearch = useCallback((value: string) => {
    setSearch(value);
  }, []);

  const { data = [], isLoading } = useGLAccountIdentifierList({ search_string: search, ...params });
  console.log(data);
  const options = data.map(item => ({
    value: item.id,
    label: showId ? `${item.lookup_type} (ID: ${item.id})` : item.lookup_type
  }));

  return (
    <Select
      onBlur={e => e.preventDefault()}
      onSearch={handleSearch}
      options={options}
      loading={isLoading}
      filterOption={false}
      notFoundContent={isLoading ? <Spin size="small" /> : null}
      {...props}
    />
  );
};

export default GLAcountSelect;
